module.exports = __webpack_public_path__ + "img/contact-technical-issues.2ba97cd.png";